import { render, staticRenderFns } from "./cotation.vue?vue&type=template&id=2b3a82eb"
import script from "./cotation.vue?vue&type=script&lang=js"
export * from "./cotation.vue?vue&type=script&lang=js"
import style0 from "./cotation.vue?vue&type=style&index=0&id=2b3a82eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports